import { Node, mergeAttributes } from '@tiptap/core'

/**
 * Callout block (info/tip boxes). Serializes to <div data-callout="variant">
 * which is whitelisted by the server side sanitizer.
 */
export default Node.create({
  name: 'callout',

  group: 'block',
  content: 'block+',
  defining: true,

  addAttributes() {
    return {
      variant: {
        default: 'info',
        parseHTML: (element) => element.getAttribute('data-callout') || 'info',
        renderHTML: (attributes) => ({ 'data-callout': attributes.variant }),
      },
    }
  },

  parseHTML() {
    return [{ tag: 'div[data-callout]' }]
  },

  renderHTML({ HTMLAttributes }) {
    return ['div', mergeAttributes(HTMLAttributes), 0]
  },

  addCommands() {
    return {
      toggleCallout:
        (variant = 'info') =>
        ({ commands, editor }) => {
          if (editor.isActive(this.name) && ! editor.isActive(this.name, { variant })) {
            return commands.updateAttributes(this.name, { variant })
          }

          return commands.toggleWrap(this.name, { variant })
        },
    }
  },
})
